export default __webpack_public_path__ + "static/media/24339222f73550ee4b435fb8ae08db80.png";